module.exports = __webpack_public_path__ + "img/logo_climapartner.84d6ba8.svg";